/** Only guest navigation intent for an automatically assigned source Secret Link.
 * Never authenticates a buyer or grants an entitlement. */
const key='ecfs.public.pendingSecretOffer.v1';
const ttl=15*60*1000;
const hex=/^[0-9a-f]{64}$/;
export type PendingSecretOffer={token:string;savedAt:number};
export function readPendingSecretOffer():PendingSecretOffer|null{
  try{
    const raw=window.sessionStorage.getItem(key);
    if(!raw)return null;
    const value=JSON.parse(raw) as PendingSecretOffer;
    if(!value||!hex.test(value.token)||!Number.isFinite(value.savedAt)||
      value.savedAt>Date.now()+60000||Date.now()-value.savedAt>ttl){
      window.sessionStorage.removeItem(key);return null;
    }
    return value;
  }catch{return null;}
}
export function savePendingSecretOffer(token:string){
  if(!hex.test(token))return;
  try{window.sessionStorage.setItem(key,JSON.stringify({
    token,savedAt:Date.now(),
  }));}catch{/* no payment authority is stored */}
}
export function clearPendingSecretOffer(){
  try{window.sessionStorage.removeItem(key);}catch{/* no storage */}
}
